var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedAwardAmount)?_c('div',{staticClass:"cart-info"},[_c('h3',{domProps:{"textContent":_vm._s(_vm.translate('lblCartInfo', { count: _vm.selectedAwardAmount }))}}),_c('a',{staticClass:"my-2 my-m-0 button button--medium button--primary",attrs:{"href":_vm.cartUrl},domProps:{"textContent":_vm._s(_vm.translate('btnGoToCart'))}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }